import {TweenMax, Linear} from 'gsap';
const Vue = require('vue');
const SizesUtils = require('../../../../../viscomjs/utils/SizesUtils');
const win = window;
let wH = 0;

Vue.component('next-chapter-ui', {
    props: {
        to: String,
        label: String,
        timeoutduration: Number,
        autoplay: Boolean
    },
    data() {
        return {
            autoplayOn: false,
            outlinedProgress: 0
        };
    },
    template: require('../../../../../../../templates/ui/next-chapter-ui.pug'),
    mounted() {
        if (this.autoplay) {
            this.getWinSize();
            this.addScrollEventListeners();
        }
    },
    watch: {
        autoplay(to) {
            if (to) {
                this.getWinSize();
                this.addScrollEventListeners();
                this.checkVisibilityStatus();
            } else this.removeScrollEventListeners();
        },
        autoplayOn(to) {
            if (to) {
                TweenMax.to(this, this.timeoutduration, {
                    outlinedProgress: 1,
                    ease: Linear.easeInOut,
                    onComplete: this.go,
                    onCompleteScope: this
                });
            } else {
                this.outlinedProgress = 0;
                TweenMax.to(this, 0.25, {
                    outlinedProgress: 0
                });
            }
        }
    },
    beforeDestroy() {
        this.stopAutoplay();
        TweenMax.killTweensOf(this);
        this.removeScrollEventListeners();
    },
    methods: {
        checkVisibilityStatus() {
            const rect = this.$el.getBoundingClientRect();
            if (rect.bottom - 2 <= wH) this.startAutoplay();
            else this.stopAutoplay();
        },
        getWinSize() {
            wH = SizesUtils.winOffsetHeight();
        },
        startAutoplay() {
            this.autoplayOn = true;
        },
        stopAutoplay() {
            this.autoplayOn = false;
        },
        onResize() {
            this.getWinSize();
            this.checkVisibilityStatus();
        },
        onScroll() {
            this.checkVisibilityStatus();
        },
        addScrollEventListeners() {
            win.addEventListener('resize', this.onResize);
            win.addEventListener('scroll', this.onScroll);
        },
        removeScrollEventListeners() {
            win.removeEventListener('resize', this.onResize);
            win.removeEventListener('scroll', this.onScroll);
        },
        go() {
            this.$router.push(this.to);
        }
    }
});
